import { appendAppLog } from './appLog';
import { adresse } from './dateien';
import { readBase64 } from './storage';

/**
 * Eine Adresse, unter der das WebView eine abgelegte Mediendatei **abspielen** kann.
 *
 * ⚠️ **Nicht als Datenadresse.** Der Videobetrachter in `MediaTabs.tsx` lädt die Datei als
 * Base64 — bei einer Aufnahme von wenigen Minuten vertretbar, weil sie einmal durchläuft. Im
 * Annotationseditor ist sie dagegen minutenlang offen, und der Prüfer springt ständig darin
 * hin und her: eine Datenadresse liegt dabei vollständig im Speicher des WebViews, und auf
 * iOS 15 ist genau das die Stelle, an der es knapp wird (s. `VideoThumbnail.swift`).
 * `convertFileSrc` liefert stattdessen eine Adresse, über die WebKit **bereichsweise** liest —
 * erst damit ist das Springen im Video überhaupt bezahlbar.
 *
 * Im Browser gibt es keinen solchen Weg; dort bleibt die Datenadresse der Rückfall. Die
 * Bearbeitung ist am Schreibtisch ohnehin nur zum Ansehen gedacht.
 *
 * ⚠️ **Scheitert es, steht es im Dateilog** — und der Fehler fliegt weiter, damit der Aufrufer
 * ihn anzeigen kann. Bis zum 2026-09-21 fingen die Aufrufer ihn mit `.catch(() => null)` ab;
 * der Editor zeigte dann eine leere Bühne, und woran es lag, war nirgends zu sehen. Dieselbe
 * Lehre wie bei `platform/ordner.ts` am selben Tag.
 */
export async function abspielAdresse(pfad: string): Promise<string | null> {
  try {
    const vomGleis = await adresse(pfad);
    if (vomGleis !== null) return vomGleis;
  } catch (fehler) {
    await appendAppLog('Wiedergabeadresse für ' + pfad + ' nicht zu bilden: ' + String(fehler), 'error');
    throw fehler;
  }

  const daten = await readBase64(pfad);
  if (!daten) return null;
  const typ = pfad.endsWith('.mp4') ? 'video/mp4' : 'video/quicktime';
  return 'data:' + typ + ';base64,' + daten;
}
